import { createSlice } from '@reduxjs/toolkit';

const upgradeSubscriptionModalSlice = createSlice({
  name: 'upgradeSubscriptionModal',
  initialState: { open: false },
  reducers: {
    openUpgradeSubscriptionModal: (state) => { state.open = true; },
    closeUpgradeSubscriptionModal: (state) => { state.open = false; },
  },
});

export const { openUpgradeSubscriptionModal, closeUpgradeSubscriptionModal } = upgradeSubscriptionModalSlice.actions;
export default upgradeSubscriptionModalSlice.reducer;